<div class="hotel-card d-flex row align-items-center">
  <!-- <div class="image col-3"> -->
  <div class="image col-12 col-md-3 d-flex position-relative">
    <img class="card-img-top mx-auto mx-md-0 img-fluid"
      src="{{hotel.HotelImagem != null && hotel.HotelImagem != '' ? hotel.HotelImagem : backgroundimage }}">
    <div *ngIf="hotel.Recomendado" class="selo-recomenda"></div>
  </div>
  <!-- <div class="details col-6"> -->
  <div class="col-12 col-md-9">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-12 col-md-9 d-flex h-100 flex-column px-3 px-md-0 pt-3 pt-md-0" style="row-gap: .75rem;">
          <div class='row'>
            <div class='col'>
              <h4 class="m-0 p-0" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                <!-- {{ hotel.Nome + (usuario?.EmpresaId != undefined && usuario?.EmpresaId !== null ? " - (" + hotel.Fornecedor + ")" : "") }} -->
                {{ hotel.Nome }}
              </h4>
            </div>
          </div>
          <div class='row'>
            <h6 *ngIf="usuario?.EmpresaId != undefined && usuario?.EmpresaId !== null" class="col-6">cód.
              {{hotel.Fornecedor}}: {{
              hotel.CodigoFornecedor }} - </h6><app-estrelas class="col-6" [estrela]="hotel.Estrelas"></app-estrelas>
          </div>
          <div class='row '>
            <div class='col'>
              <p style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ hotel.Endereco }}</p>
            </div>
          </div>
          <div class="row">
            <div class='col'>
              <div class='row'>
                <div class='col'>
                  <div>
                    <button [disabled]="carregando" class="btn btn-success w-100 w-md-50" style="margin-top: 10px"
                      (click)="abrirModal(contentHotelDetails)">
                      {{"Detalhes" |
                      translate }} </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-3 d-flex justify-content-center pb-3 pb-md-0">
          <div class="row w-100">
            <div class='col-12 align-items-center justify-content-center text-center'>
              <div class="container d-flex justify-content-center">
                <div class="row w-100 justify-content-center align-items-center">
                  <div class='col-12 justify-content-center' style="font-size: 1.2rem;">
                    {{"A partir de" | translate}}
                    <h4>{{hotel.Quartos[0].MoedaListagem.Simbolo}} {{ somaTotal(hotel.Quartos) |
                      currency:'BRL':'':'2.2-2'
                      }}</h4>
                  </div>
                  <div class='col-12 d-flex justify-content-center'>
                    <button class="btn btn-success w-100 h-md-50" [disabled]="carregando"
                      (click)="abrirModal(contentHotelQuartos)">
                      {{"Selecionar" | translate}}
                      <span *ngIf="hotel.QuantidadeSelecionada > 0">({{hotel.QuantidadeSelecionada}})</span></button>
                  </div>
                  <div *ngIf="hotel.selecionado" class='col-12 d-flex content-center mt-md-3' id="remover">
                    <!-- <a class="btn btn-block btn-outline-success" data-bs-toggle="modal" data-bs-target="#removerHotel" (click)="carregar(hotel)">Remover</a> -->
                    <button [disabled]="carregando" class="btn btn-outline-success w-100 h-md-50"
                      (click)="removerHotel(hotel)">{{"Remover" |
                      translate}}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #contentHotelDetails let-modal>
  <app-hotel-detalhes [hotel]="hotel"></app-hotel-detalhes>
</ng-template>

<ng-template #contentHotelQuartos let-modal>
  <app-hotel-quartos [Hotel]="hotel" [politicaListagem]="politicaListagem" (selecionouHotel)="selecionou($event)" (rebuscar)="rebuscar.emit()"></app-hotel-quartos>
</ng-template>